import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../../utils/commonfunction";
import * as contactServices from "../../../services/contactUs.services";
import { useTranslation } from "react-i18next";

const ContactUsView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("link_contact"), url: "/admin/cms/contactUs/list/1" },
    { title: t("link_view"), url: "" },
  ];

  // const selected_language = localStorage.getItem("system_language")
  // console.log(selected_language)

  useEffect(() => {
    contactServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("heading_contact")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("list_heading_title")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.name ? capitalizeFirstLetter(showdefault.name) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Email")}</th>
                          <td>{showdefault && showdefault?.email}</td>
                        </tr>
                        <tr>
                          <th>{t("Phone")}</th>
                          <td>{showdefault && showdefault?.phone || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Type")}</th>
                          <td>{showdefault && showdefault?.type ? capitalizeFirstLetter(showdefault.type) : "App"}</td>
                        </tr>
                        <tr>
                          <th>{t("Subject")}</th>
                          <td>{showdefault && capitalizeFirstLetter(showdefault?.subject) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Message")}</th>
                          <td>{showdefault && capitalizeFirstLetter(showdefault?.message)}</td>
                        </tr>
                        <tr>
                          <th>{t("Status")}</th>
                          <td>{showdefault && showdefault.status ? showStatus(showdefault.status) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsView;
